<!-- 结算按钮 -->
<template>
  <div>
    <!-- <van-submit-bar :price="getPrice()" :disabled="canBy" :button-text="text" @submit="onSubmit">
    </van-submit-bar> -->

    <div class="checkout-footer-bar">
      <div class="checkout-footer-total">
        <span class="checkout-footer-label">合计:</span>
        <span class="checkout-footer-amount">
          {{ orderInfo.payProductTotal }} {{ orderInfo.cardPointTypeUnit || '点' }}
        </span>
      </div>
      <div v-if="!canBy" class="checkout-footer-btn checkout-footer-btn--disabled">{{ text }}</div>
      <div
        v-else
        class="checkout-footer-btn"
        :class="{ 'checkout-footer-btn--preview': isPreviewMode }"
        @click="handleSubmit"
      >{{ text }} </div>
    </div>

    <!-- 自定义弹窗 -->
    <CustomDialog
      :visible.sync="showCustomDialog"
      title="下单须知"
      :message="serviceFeeMessage"
      confirm-text="已知晓"
      :showCancel="true"
      :countdown="0"
      @confirm="handleDialogConfirm"
      @cancel="handleDialogCancel"
    />
  </div>
</template>

<script>
import { Toast } from "vant";
import CustomDialog from '../../components/common/CustomDialog.vue';

export default {
  name: "comfirmOrderFooter",
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    settlementKey: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "结算",
    },
    canBy: {
      type: Boolean,
    },
  },
  components: {
    CustomDialog
  },
  data() {
    return {
      checked: false,
      canPut: true,
      // 自定义弹窗相关
      showCustomDialog: false,
      isSubmitting: false, // 防重复提交标志
      // 弹窗结束时间：2025-10-10 23:59:59
      // dialogEndTime: new Date('2025-10-10 23:59:59').getTime(),
    };
  },
  computed: {
    // 判断是否为预览模式
    isPreviewMode() {
      return localStorage.getItem('isPreviewMode') === 'true';
    },
    serviceFeeMessage() {
      return `<div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
        <div style="background: #fdfdfd; padding: 12px; border-radius: 10px; border: 1px solid #f2f2f2;">
          <div style="line-height: 1.8; color: #666; font-size: 12.5px;">
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">1.</span> 
              <span>日常订单一般48小时内发货，节假日顺延。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">2.</span> 
              <span>不同批次的商品包装、产地等可能更新，请以实物为准。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">3.</span> 
              <span>下单前请仔细确认订单明细及收货信息，发货后因修改地址产生的额外运费由买家承担。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">4.</span> 
              <span>生鲜、蛋糕等易腐商品在运输途中不支持退换货，不支持无理由拒收，签收后如无质量问题，不予退换。部分冷冻商品运输中可能出现软化，属正常现象，请及时冷冻储存。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">5.</span> 
              <span>为确保食品安全，食品不支持无理由退货/换货；其他商品如需退货请确保商品完好、配件齐全、不影响二次销售，由此产生的运费需由买家承担。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">6.</span> 
              <span>因买家原因（信息错误、关机、未及时取件/食用、储存不当等）导致的损失，由买家承担。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">7.</span> 
              <span>请于签收24小时内核对商品、数量、保质期等，超出24小时或拆封使用将视为认可，不予受理退换补诉求。</span>
            </p>
            <p style="margin: 8px 0; display: flex; align-items: flex-start;">
              <span style="color: #D33B2E; font-weight: bold; min-width: 18px;">8.</span> 
              <span>如遇物流高峰、恶劣天气、管制及不可抗力等，发货可能延迟，敬请谅解。</span>
            </p>
          </div>

          <p style="margin: 15px 0 0 0; color: #999; font-size: 11.5px; border-top: 1px solid #f5f5f5; padding-top: 10px; line-height: 1.5; text-align: center;">
            如有疑问可通过微信服务号在线客服进行咨询<br/>感谢您的理解与支持！
          </p>
        </div>
      </div>`;
    },
    
    // 检查是否在弹窗有效期内
    // isDialogValid() {
    //   const currentTime = new Date().getTime();
    //   return currentTime <= this.dialogEndTime;
    // }
  },
  watch: {
  },
  methods: {
    handleCheckedChang(checked) {
      this.$emit("check", checked);
    },
    // getPrice() {
    //   return parseFloat(this.orderInfo.productTotal) * 100
    // },
    onClickEditAddress() { },
    handleSubmit() {
      // 预览模式下不允许下单
      if (this.isPreviewMode) {
        Toast("预览模式不支持下单");
        return;
      }
      this.onSubmit();
    },
    async onSubmit() {
      // 防重复提交
      if (this.isSubmitting) {
        return;
      }
      
      // 检查是否在弹窗有效期内
      // if (!this.isDialogValid) {
      //   // 超过有效期，直接执行结算逻辑
      //   await this.creatOrder();
      //   return;
      // }
      
      // 在有效期内，显示弹窗
      this.showCustomDialog = true;
    },
    
    // 处理弹窗确认
    handleDialogConfirm() {
      this.showCustomDialog = false;
      // 弹窗关闭后执行实际的结算逻辑
      this.creatOrder();
    },
    
    // 处理弹窗取消
    handleDialogCancel() {
      this.showCustomDialog = false;
      // 取消操作，不执行结算逻辑
    },
    async creatOrder() {
      // 防重复提交
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true; // 设置提交状态
      
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.cardId = localStorage.getItem("cardId");
      this.$api
        .productOrderInfo({
          settlementKey: this.settlementKey,
          outOfStockStatus: this.orderInfo?.outOfStockStatus,
          consumptionType: this.orderInfo?.consumptionType || '0',
        })
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
            this.isSubmitting = false; // 重置提交状态
            return
          }
          this.isSubmitting = false;
          this.goCashier(res.data);
          Toast.clear();
        })
        .catch((err) => {
          Toast.clear();
          this.isSubmitting = false; // 重置提交状态
        });
    },
    goCashier(orderNo) {
      // 统一跳转到统一支付页面
      // 使用 replace：从浏览器历史栈移除当前结算页，避免支付流程中「返回」回到已消费快照的结算页
      this.$router.replace({
        path: "/UnifiedCashier",
        query: {
          orderNo: orderNo,
        },
      });
    }
  },
};
</script>

<style scoped>
.checkout-footer-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  min-height: 3rem;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background-color: #fff;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}
.checkout-footer-total {
  flex: 1;
  min-width: 0;
  padding: 0.5rem 0 0.5rem 0.6rem;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
.checkout-footer-label { color: #666; font-size: 0.8125rem; }
.checkout-footer-amount { color: #d33b2e; font-weight: 600; font-size: 1rem; margin-left: 0.15rem; }
.checkout-footer-btn {
  flex-shrink: 0;
  width: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d33b2e;
  color: #fff;
  font-size: 0.9375rem;
  font-weight: 500;
}
.checkout-footer-btn--disabled { background-color: #e69992; }
.checkout-footer-btn--preview { background-color: #ccc; opacity: 0.6; cursor: not-allowed; }

.van-submit-bar__text {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-right: 3.2vw;
  color: #323233;
  text-align: left;
}
</style>
